exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".register .label{color:#fff!important}.register .page-title{font-size:32px;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/tmp/build_919341db/resources/nuxt/assets","/static":"/tmp/build_919341db/resources/nuxt/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d9e04ab4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/nuxt/pages/register/index.vue
// module id = 0gYj
// module chunks = 23